import { CSSProperties } from 'react';

export const PillLabelDot = () => {
  const coreStyle: CSSProperties = {
    height: '10px',
    width: '10px',
    borderRadius: '100px',
  };
  return (
    <div className="u-flex u-posAbs u-flexAlignItemsCenter u-flexJustifyCenter">
      <div className="u-flex u-posAbs u-flexAlignItemsCenter u-flexJustifyCenter" style={{ zIndex: 1 }}>
        <div className="bg-white" style={coreStyle} />
      </div>
    </div>
  );
};
